import React, { useEffect, useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { Transactions } from '../../models/transactions-model';
import ApiService from '../../services/api-service';
import TransactionDetailsComponent from '../transaction-details/transaction-details-component';
import './transactions-component.scss';

export default function TransactionsComponent(): JSX.Element {
  const [transactions, setTransactions] = useState({} as Transactions);
  const [transactionsLoading, setTransactionsLoading] = useState(true);

  useEffect(() => {
    const api = new ApiService();
    api.getTransactionsAsync().then((transactionsResponse) => {
      setTransactions(transactionsResponse);
      setTransactionsLoading(false);
    });
  }, []);

  return (
    <div id="page-transactions">
      <h1>Transactions</h1>
      <div>
        {transactionsLoading ? (
          <ClipLoader loading={transactionsLoading} />
        ) : (
          transactions?.data?.length && (
            <div id="allCollections-tab">
              <TransactionDetailsComponent transactions={transactions} />
            </div>
          )
        )}
      </div>
    </div>
  );
}
